import { useState } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import CategoryIcon from '@mui/icons-material/Category';
import type { CategoryFilter } from '../types';
import { FilterChip } from '../FilterChip/FilterChip';

export const CATEGORIES: {
  value: CategoryFilter;
  label: string;
}[] = [
  { value: 'news', label: 'News' },
  { value: 'notifications', label: 'Notifications' },
  { value: 'tasks', label: 'Tasks' },
  { value: 'incidents', label: 'Incidents' },
];

interface TypeFilterProps {
  selectedCategories: CategoryFilter[];
  onCategoryChange: (categories: CategoryFilter[]) => void;
}

export const TypeFilter = ({
  selectedCategories,
  onCategoryChange,
}: Readonly<TypeFilterProps>) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const toggle = (cat: CategoryFilter) =>
    onCategoryChange(
      selectedCategories.includes(cat)
        ? selectedCategories.filter(c => c !== cat)
        : [...selectedCategories, cat],
    );

  return (
    <>
      <FilterChip
        label="Type"
        icon={<CategoryIcon sx={{ fontSize: 18 }} />}
        active={selectedCategories.length > 0}
        tooltip="Filter by communication type"
        onClick={e => setAnchor(e.currentTarget)}
        width={150}
      />
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: { borderRadius: '15px' },
          },
        }}
      >
        <Box sx={{ minWidth: 200 }}>
          {CATEGORIES.map(cat => {
            const isSelected = selectedCategories.includes(cat.value);
            return (
              <MenuItem
                key={cat.value}
                disableRipple
                onClick={() => toggle(cat.value)}
                sx={{
                  px: 2,
                  py: 1.25,
                  gap: 1.5,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 120, 214, 0.08)',
                  },
                }}
              >
                <Checkbox
                  size="small"
                  checked={isSelected}
                  onChange={() => toggle(cat.value)}
                  onClick={e => e.stopPropagation()}
                  sx={{
                    p: 0,
                    color: 'text.secondary',
                    '&.Mui-checked': {
                      color: 'primary.main',
                    },
                  }}
                />
                {cat.label}
              </MenuItem>
            );
          })}
        </Box>
      </Popover>
    </>
  );
};
